import React from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { useOneySimulationPopin } from './useOneySimulationPopin';
type Props = {
  price: {
    total: Price;
  };
  iconClassname: string;
  payingLabel: string;
};
export const OneyLabel = ({ price, iconClassname, payingLabel }: Props) => {
  const { handlePopinClick } = useOneySimulationPopin({
    price: price.total.value,
  });
  const oneyInstalmentCount = t('booking.banking.paymentSchedule.bnpl.oneyInstallmentCount');
  const oneyIconName = `oney_${oneyInstalmentCount}`;
  return (
    <React.Fragment>
      <div className="gap-1 flex flex-col items-start md:flex-row md:items-center md:gap-4">
        <span className="flex items-center gap-4">
          {payingLabel}
          <Icon name={oneyIconName} width="1.5rem" isNotMonoChrome />
        </span>
        <span className="ml-0 leading-tight md:ml-0">
          {t('booking.banking.paymentSchedule.byCreditCard')}
        </span>
      </div>
      <span onClick={handlePopinClick} className={iconClassname}>
        <Icon name={ICONS.INFORMATION} width="1.5rem" className="cursor-pointer" />
      </span>
    </React.Fragment>
  );
};
